<div
    class="map-sidebar container-scroll feature-groups-container"
    [ngClass]="{ expanded: true }"
>
    <ng-container *ngIf="map != null">
        <enhanced-help componentName="feature-add" [compact]="true">
        </enhanced-help>
        <div class="card" *ngFor="let featureGroup of internalFeatureGroups">
            <div class="header horizontal-container">
                <h4 class="fill">{{ featureGroup.name }}</h4>
                <button
                    type="button"
                    [disabled]="
                        isEditing || isAddingFeature || showAirspaceDisclaimer
                    "
                    class="btn btn-circle"
                    (click)="addNewFeature(featureGroup)"
                >
                    <span class="fa fa-plus"></span>
                </button>
            </div>
            <div
                *ngFor="let feature of featureGroup.existingFeatures"
                class="horizontal-container"
                [ngClass]="{
                    hover: feature.id === hoverFeatureId,
                    selected: feature.id === editFeatureId
                }"
                (mouseenter)="highlightFeature(featureGroup, feature.id)"
                (mouseleave)="unhighlightFeature(featureGroup, feature.id)"
            >
                <span class="feature-name"
                    ><a (click)="onFeatureNameSelected(feature)">{{
                        feature.name
                    }}</a></span
                >
                <action-required
                    *ngIf="isFeatureInvalid(featureGroup.id, feature.id)"
                    [noPopover]="true"
                    tooltipText="This feature has invalid geometry"
                ></action-required>
            </div>
        </div>
    </ng-container>
    <div *ngIf="type === 'MISSION'" class="card">
        <div class="header horizontal-container">
            <h4 class="fill">Mission Parameters</h4>
        </div>
        <map-airspace-parameters></map-airspace-parameters>
    </div>
</div>
<flyfreely-map
    *ngIf="airspaceValue$ | async as airspaceValue"
    #map
    airspaceCheckResult
    class="fill"
    [organisationId]="organisationId"
    [features]="internalFeatureGroups"
    (featuresUpdated)="onFeaturesUpdated($event)"
    (featureSelected)="onFeatureSelected($event)"
    (featureUnselected)="onFeatureUnselected()"
    (geocodeResultSelected)="onGeocodeResultSelected($event)"
    [showEditCompletion]="false"
    [showFeatureSelection]="false"
    (fullscreenRequested)="onFullscreenRequested()"
    (editModeChanged)="onEditModeChanged($event)"
    (featuresLoaded)="onFeaturesLoaded()"
    (featureHover)="onFeatureHover($event)"
    [featurePopupTemplate]="featurePopupTemplate"
    [startTime]="airspaceValue?.startTime"
    [endTime]="airspaceValue?.endTime"
    [ruleset]="airspaceValue?.airspaceRuleset"
    [mapData]="mapData$ | async"
    [enableLayerGroupsByDefault]="['LOTAM', 'MISSIONS']"
    [additionalImages]="additionalImages"
    (mapReady)="onMapReady()"
    (jurisdictionChanged)="onMapJurisdictionChanged($event)"
    (viewportChange)="onViewportChange($event)"
>
    <ng-template *ngIf="showAirspaceChecker" mapSidebar let-map="map">
        <map-airspace-checker
            [organisationId]="organisationId"
            [timeZone]="currentTimeZone"
            [flightArea]="flightArea"
            [initialValues]="missionValues"
            [workTracker]="workTracker"
            [jurisdiction]="map.jurisdictionChanged | async"
            [disableParameters]="type === 'MISSION'"
            (checkerParametersChange)="onAirspaceValuesUpdated($event)"
            (requestToggleFullscreen)="onFullscreenRequested()"
        ></map-airspace-checker>
    </ng-template>
</flyfreely-map>
<inline-modal
    *ngIf="showAirspaceDisclaimer"
    [show]="showAirspaceDisclaimer"
    [sizeSmall]="true"
    [topSpacing]="true"
    style="max-height: fit-content"
>
    <airspace-disclaimer
        screenIdentifier="location-edit"
        [airspaceJurisdiction]="mapJurisdiction"
        (done)="onAirspaceDisclaimerAcknowledged()"
    ></airspace-disclaimer>
</inline-modal>

<ng-template #featurePopupTemplate>
    <map-marker-toolbar
        *ngIf="selectedFeature"
        [feature]="selectedFeature.feature"
        [featureGroup]="selectedFeatureGroup"
        (onFeatureChange)="onSelectedFeatureUpdated($event)"
        (onFeatureEdit)="onFeatureEdit($event)"
        (onFeatureDelete)="onFeatureDelete($event)"
    ></map-marker-toolbar>
</ng-template>
